module.exports = __webpack_public_path__ + "static/img/jxjl1.377e2f9.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/jxjl1.png
// module id = TPVQ
// module chunks = 1